module.exports = __webpack_public_path__ + "img/home_banner_wrap4.f019aea7.png";